import { render, staticRenderFns } from "./PasswordReminder.vue?vue&type=template&id=51e277c0&scoped=true&"
import script from "./PasswordReminder.vue?vue&type=script&lang=js&"
export * from "./PasswordReminder.vue?vue&type=script&lang=js&"
import style0 from "./PasswordReminder.vue?vue&type=style&index=0&id=51e277c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e277c0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/PasswordReminder.vue
// module id = null
// module chunks = 